import { Card, CardBody, CardHeader, Row, Col } from 'reactstrap'
import PropTypes from 'prop-types'
import TimeUtil from 'utils/time-util'

const propTypes = {
  blogPost: PropTypes.shape({
    title         : PropTypes.string,
    url           : PropTypes.string,
    active_status : PropTypes.string,
    hero_img_url  : PropTypes.string,
    sections      : PropTypes.array,
    category      : PropTypes.string,
    posted_date   : PropTypes.date,
    summary       : PropTypes.string
  })
}

const defaultProps = {
  blogPost: {
    title         : '',
    url           : '',
    active_status : '',
    hero_img_url  : '',
    sections      : [
      {
        title         : 'Title',
        image_url     : '',
        description   : 'description',
        collection_id : ''
      }
    ],
    category    : 'fashion',
    posted_date : TimeUtil.format('1970-01-01T01:00:01.000'),
    summary     : 'Tinkerlust minggu ini akan menyajikan fesyen chic. . .'
  }
}

const CmsBlogPostPreviewSection = ({
  blogPost
}) => (

  <Card>
    <CardHeader>
      <h2>PREVIEW</h2>
    </CardHeader>
    <CardBody>
      <Row>
        <Col
          lg='12'
          style={{ backgroundColor: 'gray' }}
        >
          <h3 className='text-center'>Header</h3>
        </Col>
      </Row>
      <Row className='mt-2'>
        <Col lg='12'>
          <Col lg='12'>
            <Row>
              <Col lg='6'>
                <h3
                  className='text-left'
                  style={{ color: '#929191', fontWeight: '400', textTransform: 'capitalize' }}
                >
                  { TimeUtil.format(`${blogPost.posted_date}`) }
                </h3>
              </Col>
              <Col lg='6'>
                <h3
                  className='text-right'
                  style={{ color: '#ed569a', fontWeight: 'bold', textTransform: 'capitalize' }}
                >
                  { `${blogPost.category}` }
                </h3>
              </Col>
            </Row>
          </Col>
        </Col>
      </Row>
      <Row className='mt-2'>
        <Col lg='12'>
          <h2
            className='text-center'
            style={{ color: '#3c3c3c', fontSize: '26px', fontWeight: 'bold',fontFamily: '"Frank Ruhl Libre", Georgia, "Times New Roman", Times, serif', textTransform: 'uppercase' }}
          >
            { `${blogPost.title}` }
          </h2>
        </Col>
      </Row>
      <Row className='mt-4'>
        <Col
          lg='12'
          className='p-0'
          style={{ minHeight: '150px', backgroundColor: 'aqua', textAlign: 'center' }}
        >
          {
            blogPost.hero_img_url ?
              <img
                src={ `${blogPost.hero_img_url}` }
                style={{ width: '100%' }}
              />
              :
              <h3
                className='text-center'
                style={{ paddingTop: '55px' }}
              >
                Cover Image
              </h3>
          }
        </Col>
      </Row>
      <Row className='mt-2'>
        <Col lg='12'>
          <div style={{ whiteSpace: 'pre-line' }}>
            { blogPost.summary }
          </div>
        </Col>
      </Row>
      {
        blogPost.sections.map((section, index) => <Row key={ `section-${index}` } className='mt-4'>
          <Col lg='12'>
            <Row>
              <Col lg='5'>
                <h3 className='text-left'>{ `Section-${index+1}` }</h3>
              </Col>
              <Col lg='5'>
                <h3 className='text-left'>{ section.title }</h3>
              </Col>
            </Row>
            <Row>
              <Col lg='12'>
                {
                  section.image_url ?
                    <img
                      src={ `${section.image_url}` }
                      style={{ width: '100%' }}
                    />
                    :
                    <h3
                      className='text-center'
                      style={{ marginLeft: '155px', marginRight: '155px', padding: '30px', border: '1px solid black' }}
                    >
                      Image
                    </h3>
                }
              </Col>
            </Row>
            <Row>
              <Col lg='12'>
                <h3
                  className='text-center'
                  style={{ marginLeft: '0px', marginRight: '0px', padding: '30px', fontSize: '12px', marginTop: '10px', backgroundColor: '#f5f5f5', height: '100%', marginBottom: '30px', whiteSpace: 'pre-line' }}
                >
                  { section.description }
                </h3>
              </Col>
            </Row>
            <Row>
              <Col lg='12'>
                <h3
                  className='text-center'
                  style={{ marginLeft: '0px', marginRight: '0px', backgroundColor: 'orange' }}
                >
                  Product Collection
                </h3>
              </Col>
            </Row>
          </Col>
        </Row>
        )
      }

      <Row className='mt-2'>
        <Col
          lg='12'
          style={{ height: '30px', backgroundColor: 'gray', marginTop: '120px' }}
        >
          <h3 className='text-center'>Footer</h3>
        </Col>
      </Row>
    </CardBody>
  </Card>
)


CmsBlogPostPreviewSection.propTypes    = propTypes
CmsBlogPostPreviewSection.defaultProps = defaultProps

export default CmsBlogPostPreviewSection
